import { useMsal } from "@azure/msal-react";

export function User({ children }) {
  const { accounts } = useMsal();
  const user = accounts[0] || {};
  const name = user.name || "Guest";
  const email = user.username || "Guest";
  const domainGroups = user?.idTokenClaims?.roles?.filter((role) => role.startsWith("IP-AI-Assistant-") && role.endsWith("-SG"));
  return children({ name, email, domainGroups });
}
